import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  tabindex: "0",
  class: "autocomplete",
  id: "listElement"
}
const _hoisted_2 = ["onClick", "id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.anzeigen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vorschlaege, (option, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              onClick: ($event: any) => (_ctx.$emit('update', { data: option, index: index })),
              class: _normalizeClass({ selected: index === _ctx.selected }),
              id: 'item-' + index
            }, _toDisplayString(_ctx.getOptionlabel(option)), 11, _hoisted_2))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}